module.exports = __webpack_public_path__ + "static/img/w-9.1cab1a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-9.jpg
// module id = 5oDu
// module chunks = 1